import { Injectable } from '@angular/core';
import {LoggerService} from '../../../logging/services/logger.service';
import {ApiService} from '../server/api.service';
import {Notification} from '../../data/Notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  notifications: Notification[];

  constructor(private loggerService: LoggerService,
              public httpService: ApiService) { }

  async getAllNotifications(): Promise<void>{
    this.notifications = await this.httpService.applicationApiClient.get<Notification[]>(`Notification/GetNotificationsForUser`).then( x => x.reverse() );
  }

  async dismissNotification(notificationId: string): Promise<Object>{
    return await this.httpService.applicationApiClient.patch(`Notification/DismissNotification`, notificationId, null);
  }

  async dismissAllNotifications(): Promise<void>{
    await this.httpService.applicationApiClient.get(`Notification/DismissAllNotifications`);
  }

  async readNotification(notificationId: string): Promise<Object>{
    return await this.httpService.applicationApiClient.patch(`Notification/ReadNotification`, notificationId, null);
  }

  get notificationNumber(): number {
    if (!this.notifications) {
      return 0;
    }
    return this.notifications.filter(x => x.userNotifications.filter(y => y.read === false).length > 0).length;
  }
}
